import React from 'react';
import { useTheme } from '../theme';
import { SettingsIcon } from './Icons';

export interface ThemeSwitcherProps {
  showLabel?: boolean;
  showIcon?: boolean;
  className?: string;
  selectClassName?: string;
}

const themeDisplayNames: Record<string, string> = {
  light: 'Light',
  dark: 'Dark',
  'grove-light': 'Grove Light',
  'grove-dark': 'Grove Dark',
  dawn: 'Dawn',
  dusk: 'Dusk',
  cupcake: 'Cupcake',
  business: 'Business',
};

export const ThemeSwitcher: React.FC<ThemeSwitcherProps> = ({
  showLabel = true,
  showIcon = true,
  className = '',
  selectClassName = 'select-sm',
}) => {
  const { theme, setTheme, themes } = useTheme();

  return (
    <div className={className}>
      {showLabel && (
        <label className="text-sm font-medium mb-2 flex items-center gap-2">
          {showIcon && <SettingsIcon className="w-4 h-4" />}
          Theme
        </label>
      )}
      <select
        className={`select w-full ${selectClassName}`}
        value={theme}
        onChange={(e) => setTheme(e.target.value as any)}
        aria-label="Theme selector"
      >
        {themes.map((t) => (
          <option key={t} value={t}>
            {themeDisplayNames[t] || t}
          </option>
        ))}
      </select>
    </div>
  );
};
